module.exports = __webpack_public_path__ + "static/media/mx-blog-small.6223fefb.png";